import Profile from "../components/Profile"

const ProfilePage = () => {
    return <Profile />
}

export default ProfilePage
